
    import './styles.scoped.css';
    export default {
  "radio-button": "awsui_radio-button_zdbjz_18ajn_10"
};
  